// URLSearchParams stringifies undefined/null as the literal text "undefined"/"null"
// if you pass them straight through — silently corrupting query params like
// doctor_id/status that are legitimately omitted. Strip those (and empty
// strings) before building the query string.
function buildQueryString(params = {}) {
  const filtered = Object.entries(params).filter(
    ([, value]) => value !== undefined && value !== null && value !== '',
  );
  return new URLSearchParams(filtered).toString();
}

export class OpdBillingAPI {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }

  async getBillForAppointment(appointmentId) {
    return this.apiClient.get(`/api/v1/opd/billing/appointment/${appointmentId}`);
  }

  async collectPayment(billId, data) {
    return this.apiClient.post(`/api/v1/opd/billing/${billId}/payment`, data);
  }

  async getBillById(billId) {
    return this.apiClient.get(`/api/v1/opd/billing/${billId}`);
  }

  async listBills(params = {}) {
    const queryString = buildQueryString(params);
    return this.apiClient.get(`/api/v1/opd/billing/bills${queryString ? `?${queryString}` : ''}`);
  }

  async listFeeConfig() {
    return this.apiClient.get('/api/v1/opd/billing/fee-config');
  }

  async upsertFeeConfig(data) {
    return this.apiClient.put('/api/v1/opd/billing/fee-config', data);
  }

  async cancelAndRegenerate(billId, data) {
    return this.apiClient.put(`/api/v1/opd/billing/${billId}/cancel-regenerate`, data);
  }

  async refundFull(billId, data) {
    return this.apiClient.post(`/api/v1/opd/billing/${billId}/refund/full`, data);
  }

  async refundPartial(billId, data) {
    return this.apiClient.post(`/api/v1/opd/billing/${billId}/refund/partial`, data);
  }
}
